import React, { useState } from 'react';
import { LiveClassesList } from '../../../organisms/live_classes_list';
import { useYourClassesContext } from '../../context';
import { pluralize } from 'utilities/pluralize';
import { DefaultButton } from '@magoosh/lib/button';
import { DateBox } from '../../../lib/DateBox';
import moment from 'moment';

export const RecentContent: React.FC = () => {
  const { data, fetchData } = useYourClassesContext();
  const [displayCount, setDisplayCount] = useState(1);

  React.useEffect(() => {
    fetchData('recent');
  }, []);

  const handleOneMoreWeek = () => {
    setDisplayCount(displayCount + 1);
  };

  return (
    <>
      <LiveClassesList
        icon={<DateBox moment={moment()} variant="primary" />}
        title="Recordings from This Week"
        description={pluralize(
          data.recent.thisWeek.length,
          'Class Recording Available',
          'Class Recordings Available'
        )}
        liveClasses={data.recent.thisWeek}
      />
      <LiveClassesList
        icon={<DateBox moment={moment().day(-7)} variant="primary" />}
        title="Recordings from Last Week"
        description={pluralize(
          data.recent.lastWeek.length,
          'Class Recording Available',
          'Class Recordings Available'
        )}
        liveClasses={data.recent.lastWeek}
      />
      {data.recent.previousWeeks.slice(0, displayCount).map((previousClasses, index) => (
        <LiveClassesList
          key={index}
          icon={<DateBox moment={moment(previousClasses.weekOf)} variant="primary" />}
          title={`Recordings from the Week of ${previousClasses.weekOf}`}
          description={pluralize(
            previousClasses.liveClassSessions.length,
            'Class Recording Available',
            'Class Recordings Available'
          )}
          liveClasses={previousClasses.liveClassSessions}
        />
      ))}
      {data.recent.previousWeeks.length > displayCount && (
        <div className="text-center u-margin-A-s">
          <DefaultButton onClick={handleOneMoreWeek}>See One More Week</DefaultButton>
        </div>
      )}
    </>
  );
};

export default RecentContent;
